module.exports = __webpack_public_path__ + "static/media/999.27f520e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/assets/999.svg
// module id = 592
// module chunks = 20